import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  Autocomplete,
  TextField,
} from "@mui/material";
import SoftButton from "components/SoftButton";
import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import swal from "sweetalert2";
import { api } from "utils/Api";
import { useHierarchy } from "context/HierarchyContext";
import { showWarning } from "utils/messageAlerts";
import { showSuccess } from "utils/messageAlerts";

function TenantAddPropertyPopup({ onClose, refreshData }) {
  const [loading, setLoading] = useState(false);
  const [assignedUserEmail, setAssignedUserEmail] = useState("");
  const [units, setUnits] = useState([]);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const { propertyId, orgId } = useHierarchy();

  useEffect(() => {
    fetchUnits();
  }, []);

  const fetchUnits = async () => {
    try {
      const response = await api.su_unit.getSuUnits();
      const unitData = response.filter(
        (unit) => unit.property_id === parseInt(propertyId)
      );
      setUnits(unitData || []);
    } catch (e) {
      
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedUnit) {
      showWarning("Please select a unit");
      return;
    }

    if (!assignedUserEmail) {
      showWarning("Please enter user email");
      return;
    }

    setLoading(true);

    try {
      await api.assign_user_unit.assignUserToUnit({
        user_email: assignedUserEmail,
        unit_id: selectedUnit.id,
        organization_id: parseInt(orgId),
        property_id: parseInt(propertyId),
        user_role_id: 5, 
        frontend_metadata: {},
        backend_metadata: {},
      });

      showSuccess("Tenant assigned successfully.")

      onClose();
      refreshData();
    } catch (error) {
      
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={true} onClose={onClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Add Tenant to Unit</DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            {/* Searchable Property */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                Select Unit{" "}
                <Box component="span" color="error.main">
                  *
                </Box>
              </SoftTypography>

              <Autocomplete
                options={units}
                getOptionLabel={(option) => option.name || ""}
                value={selectedUnit}
                onChange={(_, newValue) => setSelectedUnit(newValue)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Search unit..."
                    size="small"
                  />
                )}
              />
            </SoftBox>

            {/* User Email */}
            <SoftBox>
              <SoftTypography variant="caption" fontWeight="bold">
                User Email{" "}
                <Box component="span" color="error.main">
                  *
                </Box>
              </SoftTypography>

              <SoftInput
                type="email"
                placeholder="Enter user email to assign as RESIDENT"
                value={assignedUserEmail}
                onChange={(e) => setAssignedUserEmail(e.target.value)}
                required
              />
            </SoftBox>
          </Box>
        </DialogContent>

        <DialogActions>
          <SoftButton onClick={onClose}>Cancel</SoftButton>
          <SoftButton
            variant="gradient"
            color="dark"
            disabled={loading}
            type="submit"
          >
            {loading ? "Saving..." : "Save"}
          </SoftButton>
        </DialogActions>
      </form>
    </Dialog>
  );
}

TenantAddPropertyPopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  refreshData: PropTypes.func.isRequired,
};

export default TenantAddPropertyPopup;